/* tslint:disable */
/* eslint-disable */
/**
 * Main API v1.0
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { AggregateKeyInfo } from './AggregateKeyInfo';
import {
    AggregateKeyInfoFromJSON,
    AggregateKeyInfoFromJSONTyped,
    AggregateKeyInfoToJSON,
} from './AggregateKeyInfo';
import type { BooleanSearch } from './BooleanSearch';
import {
    BooleanSearchFromJSON,
    BooleanSearchFromJSONTyped,
    BooleanSearchToJSON,
} from './BooleanSearch';
import type { TextSearch } from './TextSearch';
import {
    TextSearchFromJSON,
    TextSearchFromJSONTyped,
    TextSearchToJSON,
} from './TextSearch';

/**
 * 
 * @export
 * @interface ClasseSearch
 */
export interface ClasseSearch {
    /**
     * 
     * @type {TextSearch}
     * @memberof ClasseSearch
     */
    nom?: TextSearch;
    /**
     * 
     * @type {TextSearch}
     * @memberof ClasseSearch
     */
    code?: TextSearch;
    /**
     * 
     * @type {TextSearch}
     * @memberof ClasseSearch
     */
    annee?: TextSearch;
    /**
     * 
     * @type {TextSearch}
     * @memberof ClasseSearch
     */
    lieu?: TextSearch;
    /**
     * 
     * @type {BooleanSearch}
     * @memberof ClasseSearch
     */
    horaireCoherent?: BooleanSearch;
    /**
     * 
     * @type {Array<number>}
     * @memberof ClasseSearch
     */
    selectedIds?: Array<number> | null;
    /**
     * 
     * @type {Array<number>}
     * @memberof ClasseSearch
     */
    availableIds?: Array<number> | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof ClasseSearch
     */
    sortKey?: Array<string> | null;
    /**
     * 
     * @type {Array<AggregateKeyInfo>}
     * @memberof ClasseSearch
     */
    aggregateKeys?: Array<AggregateKeyInfo> | null;
    /**
     * 
     * @type {number}
     * @memberof ClasseSearch
     */
    forceSkip?: number | null;
    /**
     * 
     * @type {number}
     * @memberof ClasseSearch
     */
    forceTake?: number | null;
    /**
     * 
     * @type {any}
     * @memberof ClasseSearch
     */
    parameters?: any | null;
    /**
     * 
     * @type {string}
     * @memberof ClasseSearch
     */
    filter?: string | null;
}

/**
 * Check if a given object implements the ClasseSearch interface.
 */
export function instanceOfClasseSearch(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function ClasseSearchFromJSON(json: any): ClasseSearch {
    return ClasseSearchFromJSONTyped(json, false);
}

export function ClasseSearchFromJSONTyped(json: any, ignoreDiscriminator: boolean): ClasseSearch {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'nom': !exists(json, 'nom') ? undefined : TextSearchFromJSON(json['nom']),
        'code': !exists(json, 'code') ? undefined : TextSearchFromJSON(json['code']),
        'annee': !exists(json, 'annee') ? undefined : TextSearchFromJSON(json['annee']),
        'lieu': !exists(json, 'lieu') ? undefined : TextSearchFromJSON(json['lieu']),
        'horaireCoherent': !exists(json, 'horaireCoherent') ? undefined : BooleanSearchFromJSON(json['horaireCoherent']),
        'selectedIds': !exists(json, 'selectedIds') ? undefined : json['selectedIds'],
        'availableIds': !exists(json, 'availableIds') ? undefined : json['availableIds'],
        'sortKey': !exists(json, 'sortKey') ? undefined : json['sortKey'],
        'aggregateKeys': !exists(json, 'aggregateKeys') ? undefined : (json['aggregateKeys'] === null ? null : (json['aggregateKeys'] as Array<any>).map(AggregateKeyInfoFromJSON)),
        'forceSkip': !exists(json, 'forceSkip') ? undefined : json['forceSkip'],
        'forceTake': !exists(json, 'forceTake') ? undefined : json['forceTake'],
        'parameters': !exists(json, 'parameters') ? undefined : json['parameters'],
        'filter': !exists(json, 'filter') ? undefined : json['filter'],
    };
}

export function ClasseSearchToJSON(value?: ClasseSearch | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'nom': TextSearchToJSON(value.nom),
        'code': TextSearchToJSON(value.code),
        'annee': TextSearchToJSON(value.annee),
        'lieu': TextSearchToJSON(value.lieu),
        'horaireCoherent': BooleanSearchToJSON(value.horaireCoherent),
        'selectedIds': value.selectedIds,
        'availableIds': value.availableIds,
        'sortKey': value.sortKey,
        'aggregateKeys': value.aggregateKeys === undefined ? undefined : (value.aggregateKeys === null ? null : (value.aggregateKeys as Array<any>).map(AggregateKeyInfoToJSON)),
        'forceSkip': value.forceSkip,
        'forceTake': value.forceTake,
        'parameters': value.parameters,
        'filter': value.filter,
    };
}

